"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUploadSnapshot = void 0;
var _react = require("react");
var _alloyReactNotification = require("@adsk/alloy-react-notification");
var _issueSnapshots = require("../../../../state/redux/ducks/issueSnapshots");
var _hooks = require("../../../../state/redux/hooks");
var _featureFlags = require("../../../../utils/featureFlags");
var _useSdk = require("../../../../state/sdk/useSdk");
var _DocsApi = require("../../../../docs-service/DocsApi");
var _alloyProvider = require("@adsk/alloy-provider");
var _useTranslations = require("../../../../utils/i18n/useTranslations");
var _useSnapshotAbortController = require("./useSnapshotAbortController");
var _issueLinkedDocumentsUtils = require("../../../../utils/data/issueLinkedDocumentsUtils");
const useUploadSnapshot = () => {
  const dispatch = (0, _hooks.useDispatch)();
  const {
    showNotification
  } = (0, _alloyReactNotification.useNotifications)();
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  const {
    value: displayThumbnailField
  } = (0, _featureFlags.useFeatureFlag)(_featureFlags.FeatureFlag.DisplayIssueThumbnailField);
  const {
    getSignal,
    throwIfAborted,
    isAbortError
  } = (0, _useSnapshotAbortController.useSnapshotAbortController)();
  const docsSdk = (0, _DocsApi.getDocsApi)();
  const sdk = (0, _useSdk.useSdk)();
  const projectId = (0, _alloyProvider.useCurrentProjectId)();
  return (0, _react.useCallback)(async _ref => {
    let {
      issue,
      snapshotBlob,
      hasMarkups,
      flowId
    } = _ref;
    if (!projectId || !displayThumbnailField || !snapshotBlob || !(0, _issueLinkedDocumentsUtils.is3dIssue)(issue)) {
      return;
    }
    try {
      // Avoid starting upload if the flow was aborted
      throwIfAborted(flowId);
      dispatch((0, _issueSnapshots.issueSnapshotUploadStart)({
        issueId: issue.id,
        snapshotBlob,
        hasMarkups,
        flowId
      }));
      const {
        objectId: storageUrn
      } = await docsSdk.Projects.getStorage(projectId, {
        fileName: "issue-snapshot_".concat(issue.id, "_").concat(Date.now(), ".jpg")
      });
      const {
        urls,
        uploadKey
      } = await sdk.Oss.getUploadLink(storageUrn);
      const [signedS3UploadUrl] = urls;
      await sdk.Oss.uploadObject(signedS3UploadUrl, snapshotBlob, {
        signal: getSignal(flowId)
      });

      // Avoid finalizing the upload if the flow was aborted
      throwIfAborted(flowId);

      // Let OSS know object is fully uploaded
      await sdk.Oss.finalizeUploadObject(storageUrn, uploadKey);
      return storageUrn;
    } catch (e) {
      if (isAbortError(e)) {
        return;
      }
      dispatch((0, _issueSnapshots.issueSnapshotFailure)({
        issueId: issue.id
      }));
      showNotification({
        status: _alloyReactNotification.NOTIFICATION_STATUSES.ERROR,
        message: T.translate("thumbnailField.failureMessage")
      });
    }
  }, [T, dispatch, displayThumbnailField, docsSdk.Projects, getSignal, throwIfAborted, isAbortError, projectId, sdk.Oss, showNotification]);
};
exports.useUploadSnapshot = useUploadSnapshot;
//# sourceMappingURL=useUploadSnapshot.js.map